<template>

	<div id="article-page">
		<section class="container content-section" v-if="!!selectedCom">
			<div class="row">
				<div class="col-12 mb-2 col-title-s1">
					<h3 class="title">{{selectedCom.titulo}}</h3>
				</div>

				<!-- Artículo actual -->
				<div class="col-lg-8 col-article">
					<div class="box-image" v-if="!!selectedCom.imagenes_id">
						<api-img :comp="selectedCom.imagenes_id" />
					</div>
					<div class="descr">
						<vue-simple-markdown :source="selectedCom.descripcion"/>
					</div>
				</div>

				<!-- Artículos -->
				<div class="col-lg col-blog">
					<div class="row">
					<div class="col-12 col-article-sample-1 sample-2" v-for="arti in hashedComs" :key="arti.id">

						<router-link class="box-article" :to="'/comunicados/' + arti.id">

						<div class="placed-backg box-image">
							<api-img :comp="arti.imagenes_id" size="350/220"/>
						</div>

						<div class="box-descr">
							<h5>{{arti.titulo}}</h5>
							<div class="descr"> <p> {{arti.extracto}} </p> </div>
						</div>

						</router-link>
					</div>
					</div>
				</div>

			</div>
		</section>

		<section class="container content-section" v-else>
			<b-jumbotron header="No fue posible localizar la información">
				<p>
					Por favor actualiza la página o intenta mas tarde
				</p>
				<router-link to="/">
					<b-button variant="primary">Ir a inicio</b-button>
				</router-link>
			</b-jumbotron>
		</section>

	</div>

</template>

<script>
	import _ from 'lodash'
	import { mapGetters } from 'vuex'

	export default {
		computed: {
			...mapGetters(['catalogosGetComunicados']),
			hashedComs(){
				return _.take(_.filter(this.catalogosGetComunicados, item => {
					return (item.id != this.$route.params.id)
				}), 5)
			},	
			selectedCom(){
				let found = _.find(this.catalogosGetComunicados, {id: this.$route.params.id})
				return found
			},
		}
	}
</script>

<style scoped>
	.descr {
		white-space: pre-line;
	}
</style>